if (!customElements.get('buybox-no-subscriptions')) {
  class BuyboxNoSubscriptions extends HTMLElement {
    constructor() {
      super()

      this.form = this.closest('form')
      this.variantInput = this.form?.querySelector('input[name="id"]')
      this.purchaseOptions = Array.from(this.querySelectorAll('[data-otp-option]'))
      this.atcButton = this.form?.querySelector('[data-buy-buttons-atc]')
      this.buyButtonPrice = this.atcButton?.querySelector('[data-buy-button-price]')
      this.buyButtonLabel = this.atcButton?.querySelector('.button-text-transform')
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
    }

    connectedCallback() {
      this.form?.classList.add('has-product-subscriptions-v2')
      this.addEventListener('change', this.handleChange)
      this.form?.addEventListener('submit', this.handleSubmit, { capture: true })

      const selectedOption = this.querySelector('[data-otp-option]:checked')
      if (selectedOption) {
        this.selectOption(selectedOption)
      }
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange)
      this.form?.removeEventListener('submit', this.handleSubmit, { capture: true })
    }

    handleChange(event) {
      const option = event.target.closest('[data-otp-option]')
      if (!option || !this.contains(option)) return

      this.selectOption(option)
    }

    handleSubmit() {
      this.removeSellingPlanFields()
    }

    selectOption(option) {
      const isAvailable = option.dataset.available === 'true'

      this.purchaseOptions.forEach((purchaseOption) => {
        const card = purchaseOption.closest('[data-otp-card]')
        card?.classList.toggle('active', purchaseOption === option)
      })

      if (this.variantInput) {
        this.variantInput.disabled = false
        this.variantInput.value = option.value
      }

      if (this.buyButtonPrice) {
        this.buyButtonPrice.textContent = `${option.dataset.perBottlePrice} ${this.dataset.perBottleSuffix} – `
      }

      if (this.buyButtonLabel) {
        this.buyButtonLabel.textContent = isAvailable ? this.dataset.addLabel : this.dataset.soldOutLabel
      }

      if (this.atcButton) {
        this.atcButton.disabled = !isAvailable
      }

      this.removeSellingPlanFields()
    }

    removeSellingPlanFields() {
      this.form?.querySelectorAll('[name="selling_plan"], [data-selling-plan-input]').forEach((input) => {
        input.removeAttribute('name')
        input.value = ''
      })
    }
  }

  customElements.define('buybox-no-subscriptions', BuyboxNoSubscriptions)
}
